/**
 * Sesión de invitado del canal de integradores.
 *
 * Un invitado entra por un enlace de pago desde una app externa. Su sesión solo
 * alcanza para ver y pagar un contrato: no tiene navegación, ni perfil, ni
 * acceso al resto del portal.
 *
 * Eso crea un riesgo que no existe con un usuario normal: si aterriza en
 * cualquier otra ruta queda encerrado, porque no hay menú desde donde salir y
 * la pantalla de "no autorizado" ofrece volver a home — justo la ruta que no
 * puede abrir. Este módulo concentra las tres respuestas: reconocerlo, saber a
 * dónde devolverlo, y darle una salida limpia.
 */

const readUserData = () => {
  try {
    return JSON.parse(localStorage.getItem("userData") || "{}") || {}
  } catch (e) {
    return {}
  }
}

export const isGuestSession = () => readUserData().role === "guest"

/**
 * Contrato al que está atada la sesión, o null si no es una sesión de invitado.
 */
export const guestContractId = () => {
  const { role, contractId } = readUserData()

  return role === "guest" && contractId ? Number(contractId) : null
}

/**
 * Ruta a la que pertenece el invitado. Es la única que su sesión puede abrir,
 * así que es el destino correcto cuando intenta ir a cualquier otro lado.
 */
export const guestHomePath = () => {
  const id = guestContractId()

  return id ? `/pagar/${id}` : null
}

/**
 * Cierra la sesión de invitado y devuelve al login.
 *
 * Hace falta una salida explícita: la sesión de invitado PISA la que hubiera en
 * ese navegador. Si alguien abre un enlace de pago en su navegador de escritorio
 * pierde su sesión del portal, y sin esto no tendría forma de recuperarla.
 */
export const clearGuestSession = () => {
  localStorage.removeItem("accessToken")
  localStorage.removeItem("refreshToken")
  localStorage.removeItem("userData")
}
